<template>
    <div>
        <div v-if="waiting">
            <img :class="sizeCss" src="/images/spinner.gif" alt="loading"/>
        </div>
        <slot v-else></slot>
    </div>

</template>

<script>
export default {
    name: "spinner",
    props: {
        waiting: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: 'big',
        }
    },
    computed: {
        sizeCss() {
            switch(this.size) {
                case 'small':
                    return 'spinner-show-small';
                case 'medium':
                    return 'spinner-show-medium';
                case 'big':
                default:
                    return 'spinner-show-big';
            }
        }
    }
}
</script>

<style scoped>
img.spinner-show-small {
    max-height: 30px;
}
img.spinner-show-medium {
    max-height: 100px;
}
img.spinner-show-big {
    max-height: 100%;
}

</style>
